import { Injectable } from '@angular/core';
import { IPaymentSource } from '@core/interfaces/payment/payment-source.interface';
import { Payment } from '@core/models/payment/payment.model';
import { IPayment } from '@core/interfaces/payment/payment.interface';
import { Observable } from 'rxjs';
import { ListResult } from '@core/models/list-result/list-result.model';
import { take, map } from 'rxjs/operators';
import { IListResult } from '@core/interfaces/list-result/list-result.interface';

@Injectable()
export class PaymentService {

  constructor(
    private paymentSourceService: IPaymentSource
  ) { }

  getPaymentMethods(): Observable<ListResult<Payment, IPayment>> {
    return this.paymentSourceService.getPaymentMethods()
      .pipe(
        take(1),
        map((iListResult: IListResult<IPayment>) =>
          new ListResult<IPayment, Payment>(iListResult, Payment))
      );
  }

}
